import React from 'react'
import  accessControlPhoto from "./accessControl.png";
import  profilPhoto from "./profile.png";
import {NavLink, Route} from "react-router-dom";

const Menu = ({username ,userRole}) =>{
    return (
        <div>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* Brand Logo */}
                <NavLink to={'/Home'} className="brand-link">
                    <img src={accessControlPhoto}  alt="AdminLTE Logo"
                         className="brand-image img-circle elevation-3" style={{opacity: '.8'}}/>
                    <span className="brand-text font-weight-light">SEMAcademy</span>
                </NavLink>
                {/* Sidebar */}
                <div className="sidebar">
                    {/* Sidebar user panel (optional) */}
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div className="image">
                            <img src={profilPhoto} className="img-circle elevation-2"
                                 alt="User Image"/>
                        </div>
                        <div className="info">
                            <NavLink to={'/profile'}
                                     className="d-block">{username?username:"Istifadəçı Adı"}</NavLink>
                        </div>
                    </div>
                    {/* Sidebar Menu */}
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                            data-accordion="false">
                            <li className="nav-header">Menu</li>
                            {userRole==='ADMIN' &&
                            <li className="nav-item">
                                <NavLink to={'/products'} className="nav-link">
                                    <i className="nav-icon fas fa-dice-d20"/>
                                    <p>
                                        Mehsullar
                                        {/*<span className="badge badge-info right">2</span>*/}
                                    </p>
                                </NavLink>
                            </li>}
                            {userRole==='ADMIN' &&
                            <li className="nav-item">
                                <NavLink to={'/blogs'} className="nav-link">
                                    <i className="nav-icon fas fa-blog"/>
                                    <p>
                                        Blogs
                                        {/*<span className="badge badge-info right">2</span>*/}
                                    </p>
                                </NavLink>
                            </li>}
                            {userRole==='ADMIN' &&
                            <li className="nav-item">
                                <NavLink to={'/productType'} className="nav-link">
                                <i className="nav-icon fab fa-mix"/>
                                <p>
                                Məhsul Növü
                                </p>
                                </NavLink>
                                </li>}
                            {userRole==='ADMIN' &&
                            <li className="nav-item">
                                <NavLink to={'/sales'} className="nav-link">
                                    <i className="nav-icon fas fa-money-bill-wave"/>
                                    <p>
                                        Satış
                                        {/*<span className="badge badge-info right">2</span>*/}
                                    </p>
                                </NavLink>
                            </li>}
                            {userRole==='ADMIN' &&
                            <li className="nav-item">
                                <NavLink to={'/users'} className="nav-link">
                                    <i className="nav-icon fas fa-users"/>
                                    <p>
                                        İstifadəçilər
                                    </p>
                                </NavLink>
                            </li>}
                            {/*{userRole==='ADMIN' &&*/}
                            {/*<li className="nav-item">*/}
                            {/*    <NavLink to={'/Device'} className="nav-link">*/}
                            {/*    <i className="nav-icon fas fa-cog"/>*/}
                            {/*    <p>*/}
                            {/*    Avadanlıqlar*/}
                            {/*    </p>*/}
                            {/*    </NavLink>*/}
                            {/*    </li>}*/}
                            {/*<li className="nav-item">*/}
                            {/*    <NavLink to={'/Client'} className="nav-link">*/}
                            {/*        <i className="nav-icon fas fa-users"/>*/}
                            {/*        <p>*/}
                            {/*            İstifadəçilər*/}
                            {/*        </p>*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}
                            {/*{userRole==='ADMIN' &&<li className="nav-item">*/}
                            {/*    <NavLink to={'/AppUsers'} className="nav-link">*/}
                            {/*        <i className="nav-icon fas fa-user-circle"/>*/}
                            {/*        <p>*/}
                            {/*            Proqram İstifadəçisi*/}
                            {/*        </p>*/}
                            {/*    </NavLink>*/}
                            {/*</li>}*/}
                        </ul>
                    </nav>
                    {/* /.sidebar-menu */}
                </div>
                {/* /.sidebar */}
            </aside>
        </div>

    )
}

export default Menu;
